import { LoaderFunctionArgs, Outlet } from 'react-router';

import { TCustomRouteObject } from '@/shared/types/router.types';
import { WorkstationFragment } from '@/shared/types/types.generated';

export const sraRoutesConfig: TCustomRouteObject = {
  path: 'sra',
  Component: () => <Outlet />,
  handle: {
    crumb: {
      label: 'sra',
      localized: true,
    },
  },
  children: [
    {
      path: 'workstations',
      Component: () => <Outlet />,
      handle: {
        crumb: {
          label: 'workstations',
          localized: true,
        },
      },
      children: [
        {
          index: true,
          lazy: async () => {
            const { WorkstationListRoute } = await import('./workstation-list');
            return { Component: WorkstationListRoute };
          },
        },
        {
          path: ':workstationId/:tabId?',
          lazy: async () => {
            const { WorkstationRoute } = await import('./workstation');
            return { Component: WorkstationRoute };
          },
          shouldRevalidate: () => false,
          loader: async (args: LoaderFunctionArgs) => {
            const { workstationLoader } = await import('./workstation');
            return workstationLoader(args);
          },
          handle: {
            crumb: {
              label: (data: WorkstationFragment) => data.name,
            },
          },
        },
      ],
    },
  ],
};
